/**
 * The MIT License (MIT)
 * https://github.com/aurelia/dependency-injection
 *
 * Copyright (c) 2010 - 2018 Blue Spire Inc.
 */
import { FactoryResolver } from '../resolvers/FactoryResolver';
import { decorateParameterOrProperty } from './decorateParameterOrProperty';
/**
 * Decorator: Specifies the dependency to create a factory method, that can accept optional arguments
 */
export function Factory(keyValue) {
    var resolver = FactoryResolver.of(keyValue);
    return decorateParameterOrProperty(function (x) { return resolver; }, 'factory');
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmFjdG9yeS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImZhY3RvcnkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7O0dBS0c7QUFDSCxPQUFPLEVBQUUsZUFBZSxFQUFFLE1BQU0sOEJBQThCLENBQUM7QUFFL0QsT0FBTyxFQUFFLDJCQUEyQixFQUFFLE1BQU0sK0JBQStCLENBQUM7QUFFNUU7O0dBRUc7QUFDSCxNQUFNLFVBQVUsT0FBTyxDQUFDLFFBQWtCO0lBQ3RDLElBQU0sUUFBUSxHQUFHLGVBQWUsQ0FBQyxFQUFFLENBQUMsUUFBUSxDQUFDLENBQUM7SUFFOUMsT0FBTywyQkFBMkIsQ0FBQyxVQUFDLENBQUMsSUFBSyxPQUFBLFFBQVEsRUFBUixDQUFRLEVBQUUsU0FBUyxDQUFDLENBQUM7QUFDbkUsQ0FBQyJ9